import { ReactComponent as AttentionIcon } from '../../../assets/icons/attention.svg';
import { Typography } from '../../atoms';
import { InfoTooltip } from '../InfoTooltip';
import { useTranslation } from 'react-i18next';
import { GoalPriorityEnum } from '../../../common/types';
import { styled } from '@mui/material/styles';

type Props = {
    color: string;
    isOnTarget: boolean;
    goalPriority: GoalPriorityEnum;
    thresholdValue: number;
    isPDF?: boolean;
    isGoalRealistic?: boolean;
    onGoalClick?: () => void;
    onAccountsClick?: () => void;
    onIncomeSourcesClick?: () => void;
};

export const ProbabilityOfSuccessLegend = ({
    color,
    isOnTarget,
    goalPriority,
    thresholdValue,
    isPDF,
    isGoalRealistic = true,
    onGoalClick,
    onAccountsClick,
    onIncomeSourcesClick
}: Props) => {
    const { t } = useTranslation();

    const infoText = t(`PROBABILITY_OF_SUCCESS_HELPER_` + goalPriority?.toUpperCase());

    return (
        <Container>
            <Border color={color} />
            <Header>
                {!isOnTarget && (
                    <AttentionIcon width={18} height={18} color={color} style={{ marginRight: '8px', color }} />
                )}
                <Typography variant="body.overline" sx={{ textTransform: 'uppercase', color }}>
                    {t(isOnTarget ? 'PLAN_IS_ON_TARGET' : 'PLAN_NEEDS_ATTENTION')}
                </Typography>
            </Header>
            {isGoalRealistic ? (
                <>
                    <Description>
                        <Typography variant="body.large" sx={{ display: 'ruby' }}>
                            {t(isOnTarget ? 'PLAN_ON_TARGET_DESC' : 'PLAN_INCREASE_MORE_GOAL', {
                                thresholdValue
                            })}

                            {!isPDF && <InfoTooltip message={infoText} />}
                        </Typography>
                    </Description>

                    {!isOnTarget && (
                        <Typography
                            variant="body.large"
                            t="THREADSHOLD_VALUE_MESSAGE"
                            tProps={{ goalType: goalPriority, thresholdValue }}
                        ></Typography>
                    )}
                </>
            ) : (
                <Typography variant="body.large" sx={{ display: 'block' }}>
                    {t('PLAN_GOAL_UNREALISTIC_MESSAGE1')}{' '}
                    <LinkText onClick={onGoalClick}>{t('PLAN_GOAL_UNREALISTIC_MESSAGE_GOAL')}</LinkText>{' '}
                    {t('PLAN_GOAL_UNREALISTIC_MESSAGE2')}{' '}
                    <LinkText onClick={onAccountsClick}>{t('PLAN_GOAL_UNREALISTIC_MESSAGE_ACCOUNTS')}</LinkText>{' '}
                    {t('PLAN_GOAL_UNREALISTIC_MESSAGE_AND')}{' '}
                    <LinkText onClick={onIncomeSourcesClick}>
                        {t('PLAN_GOAL_UNREALISTIC_MESSAGE_INCOMESOURCES')}
                    </LinkText>
                    .
                </Typography>
            )}
        </Container>
    );
};

const Container = styled('div')(() => ({
    position: 'relative',
    left: 0,
    width: '310px',
    paddingLeft: '12px',
    paddingBottom: '2px',
    marginBottom: '20px'
}));

const Border = styled('span')<{ color: string }>(({ color }) => ({
    background: color,
    width: '4px',
    height: '100%',
    borderRadius: '15px',
    position: 'absolute',
    left: 0,
    top: 0
}));

const Header = styled('div')(() => ({
    display: 'flex',
    alignItems: 'center',
    marginBottom: '10px'
}));

const Description = styled('div')(() => ({
    marginBottom: '10px',
    display: 'block'
}));

const LinkText = styled('button')(({ theme }: any) => ({
    ...theme.typography.body.link.small,
    color: '#416AF4',
    marginBottom: 'auto',
    cursor: 'pointer',
    fontSize: '16px'
}));
